import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import PendingApproval from "@/pages/PendingApproval";
import Dashboard from "@/pages/Dashboard";
import Visitors from "@/pages/Visitors";
import Notices from "@/pages/Notices";
import Bills from "@/pages/Bills";
import Complaints from "@/pages/Complaints";
import Directory from "@/pages/Directory";
import Guard from "@/pages/Guard";
import DailyHelp from "@/pages/DailyHelp";
import WalkinApprove from "@/pages/WalkinApprove";
import Layout from "@/components/Layout";
import { ProtectedRoute, RoleRoute } from "@/components/RoleRoute";
import InstallPwaBanner from "@/components/InstallPwaBanner";
import ErrorBoundary from "@/components/ErrorBoundary";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/pending-approval" element={<PendingApproval />} />
            <Route path="/walkin/:id" element={<WalkinApprove />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/visitors" element={<Visitors />} />
                <Route path="/daily-help" element={<RoleRoute roles={["admin", "guard"]}><DailyHelp /></RoleRoute>} />
                <Route path="/notices" element={<Notices />} />
                <Route path="/bills" element={<Bills />} />
                <Route path="/complaints" element={<Complaints />} />
                <Route path="/directory" element={<Directory />} />
                <Route path="/guard" element={<RoleRoute roles={["guard", "admin"]}><Guard /></RoleRoute>} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <ErrorBoundary>
                <BrowserRouter>
                    <AuthProvider>
                        <Toaster position="bottom-right" richColors closeButton />
                        <AppRouter />
                        <InstallPwaBanner />
                    </AuthProvider>
                </BrowserRouter>
            </ErrorBoundary>
        </div>
    );
}

export default App;
